/** Reads every document type of an account (system and free, archived included). */
class FetchDocumentTypes {
	constructor(public readonly accountId: number) {
		Object.freeze(this);
	}
}

export default FetchDocumentTypes;
